
<template>
  <v-container>
    <template>
      <div class="d-flex flex-column">
        <span class="text-center text-h3 my-2">Página do Vendedor</span>
        <home-greetings class="mt-2"></home-greetings>
      </div>
      <v-row class="mt-3 d-flex justify-space-around">
        <v-col v-for="action in seller_actions" cols="6" xs="6" md="3" class="pa-1 mb-1">
          <v-card @click="selectAction(action)" link height="100%" :disabled="action.disabled">
            <v-sheet height="200" class="d-flex justify-center align-center">
              <v-icon size="80">{{action.icon}}</v-icon>
            </v-sheet>
            <v-card-title class="d-flex justify-center align-center error white--text">
              <v-sheet height="85" class="d-flex align-stretch justify-center text-center error white--text" style="word-break: break-word;" width="100%">
                {{action.text}}
              </v-sheet>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
      <span class="d-flex justify-center mt-5">Clique para ir para página</span>

    </template>
  </v-container>
</template>

<script>

export default {
  name: 'SellerView',
  components: {
    HomeGreetings: () => import('./Greetings'),
  },
  data() {
    return {
      seller_actions: [
        {text:"Gestão", icon:"mdi-text-box-outline", go_to: "HomeView"},
        {text:"Histórico de Pedidos", icon:"mdi-history", go_to: "OrdersHistory"},
        {text:"Relatório de Vendas", icon:"mdi-store", go_to: "SellDashboard"},
        {text:"Agenda de Pedidos", icon:"mdi-calendar", go_to: "OrdersAgenda"},
        {text:"Novo Pedido", icon:"mdi-file-document-plus", go_to:"CreateOrder"},
        {text:"Novos Clientes", icon:"mdi-clipboard-account-outline", disabled:true},
        {text:"CRM", icon:"mdi-list-box", disabled:true},
      ]
    }
  },
  methods: {
    selectAction(action){
      if(action.go_to){
        this.$router.push({name: action.go_to})
      }
    }
  },
  mounted () {
  },
}
</script>
